import { COMPANY } from "../data/insurances";

export default function SafeLifeLogo({ className = "h-10", variant = "full" }) {
  // variant: "full" (logo+text image), "icon" (just image as-is, acts as link)
  return (
    <img
      src={COMPANY.logoUrl}
      alt="Safe Life Corretora de Seguros"
      className={`${className} object-contain`}
      data-testid="safelife-logo"
    />
  );
}
